import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MarkersModal from '@components/map/markers-modal';

const MapComponents = ({ children }) => (
  <div>
    <MarkersModal small />
    {children}
  </div>
);

MapComponents.propTypes = {
  children: PropTypes.node
};

export default memo(MapComponents);
